module.exports = __webpack_public_path__ + "static/media/Milk_lite3.40629d37.jpg";